/* --------------------------------------
                LOGIN MENU
 -------------------------------------- */
loginMenu = {
    init: function () {
        $(".open-login-menu").on('click', function (e) {
            $(".login-menu").toggleClass('open');
        });

        $(window).scroll(function (event) {
            $(".login-menu").removeClass('open');
        });
    }
};


$(function () {
    loginMenu.init();
});